export default __webpack_public_path__ + "static/media/Ananthus-resume.327db720.pdf";